'use strict';

var React = require('react');

var PropTypes = require('prop-types');

module.exports = function render(props) {
  var innerHtml = '<path d="M2 9c0-3.86 3.14-7 6.999-7 3.859 0 6.999 3.14 6.999 7 0 1.93-.78 3.68-2.05 4.95A6.972 6.972 0 0 1 8.998 16C5.14 16 2 12.86 2 9m19.708 11.29l-5.68-5.68A8.963 8.963 0 0 0 17.998 9c0-4.96-4.03-9-9-9C4.04 0 0 4.04 0 9s4.04 9 8.999 9a8.91 8.91 0 0 0 5.609-1.98l5.69 5.69a1 1 0 0 0 1.41 0c.39-.39.39-1.03 0-1.42"/><!-- Filename: sourceSvg/action/search.svg -->';
  var svgProps = {
    className: props.className ? props.className + ' uig-svg-icon' : 'uig-svg-icon',
    dangerouslySetInnerHTML: {
      __html: innerHtml
    },
    viewBox: '0 0 22 22'
  };
  return React.createElement('svg', Object.assign({}, props, svgProps));
};